import React from 'react';
import Dropdown from './project/Dropdown';

const textOf = (node) => {
  if (node === null || node === undefined || typeof node === 'boolean') return '';
  if (Array.isArray(node)) return node.map(textOf).join('');
  if (typeof node === 'object') return textOf(node.props?.children);
  return String(node);
};

/**
 * Sostituto di <select> con lo stesso uso (`value`, `onChange(e)` con
 * `e.target.value` stringa, figli <option>, `required`, `disabled`), ma con
 * il menu personalizzato di Dropdown.
 */
function Select({ value, onChange, children, className = '', style, required = false, disabled = false, name, id, pill = false, swatch = false, searchable = false, 'aria-label': ariaLabel }) {
  const options = React.Children.toArray(children)
    .filter((child) => React.isValidElement(child) && child.type === 'option')
    .map((child) => ({
      value: child.props.value !== undefined ? child.props.value : textOf(child.props.children),
      label: textOf(child.props.children),
      color: child.props['data-color'],
    }));

  const current = value === null || value === undefined ? '' : String(value);

  return (
    <>
      <Dropdown
        id={id}
        className={className}
        style={style}
        value={current}
        options={options}
        disabled={disabled}
        pill={pill}
        swatch={swatch}
        searchable={searchable}
        ariaLabel={ariaLabel}
        onChange={(next) => onChange && onChange({ target: { value: String(next), name } })}
      />
      {required && (
        <input
          tabIndex={-1}
          aria-hidden="true"
          required
          value={current}
          onChange={() => {}}
          style={{ position: 'absolute', width: 1, height: 1, padding: 0, margin: 0, border: 0, opacity: 0, pointerEvents: 'none' }}
        />
      )}
    </>
  );
}

export default Select;
